import { render, staticRenderFns } from "./Medicamento.vue?vue&type=template&id=55735c00"
import script from "./Medicamento.vue?vue&type=script&lang=js"
export * from "./Medicamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports